import { cx } from 'class-variance-authority';
import { DeletePhotoIcon } from '../icons/DeletePhotoIcon';
import React from 'react';
import SafeImage from '@ui/SafeImage';
import { ProductDocument } from 'models/product';

export const ImageList = ({
  images,
  deleteImage,
  onMainImageSelect,
}: {
  images?: Array<ProductDocument['images'][0]>;
  deleteImage: (
    img: ProductDocument['images'][0],
    currentImages: Array<ProductDocument['images'][0]>
  ) => void;
  onMainImageSelect?: (paths: ProductDocument['images'][0][]) => void;
}) => {
  return (
    <div className="flex flex-wrap gap-[1.6rem]">
      {images?.map((image, index) => {
        return (
          <div
            draggable
            onDragStart={(e) => {
              e.dataTransfer.setData('text/plain', index.toString());
            }}
            onDragOver={(e) => {
              e.preventDefault();
            }}
            onDrop={(e) => {
              const dragIndex = parseInt(
                e.dataTransfer.getData('text/plain'),
                10
              );
              const dropIndex = index;
              const newImages = [...(images ?? [])];
              const draggedImage = newImages[dragIndex];
              newImages.splice(dragIndex, 1);
              newImages.splice(dropIndex, 0, draggedImage);
              onMainImageSelect?.(newImages);
            }}
            key={image?.thumb ?? 'key-' + index}
            onClick={() => {
              //make this image first
              const newImages = [...(images ?? [])];
              const draggedImage = newImages[index];
              if (!draggedImage) return;
              newImages.splice(index, 1);
              newImages.splice(0, 0, draggedImage);
              onMainImageSelect?.(newImages);
            }}
            className={cx([
              'relative aspect-square w-[7.5rem] cursor-pointer rounded-[1.6rem] shadow-md sm:w-[12rem]',
              index === 0 ? 'border-4 border-brand-secondary' : '',
            ])}
          >
            <ListingImage image={image} />
            {/* mWeb button */}
            <button
              type="button"
              className="absolute right-[.6rem] top-[.6rem] z-20 flex flex-col items-center justify-center sm:hidden"
              onClick={(e) => {
                e.stopPropagation();
                deleteImage(image, images ?? []);
              }}
            >
              <DeletePhotoIcon height={20} width={20} />
            </button>

            {/* dWeb overlay */}
            <div className="absolute left-0 top-0 z-10 hidden aspect-square h-full w-[12rem] flex-col items-center justify-center  opacity-0 transition-all hover:opacity-100  sm:flex">
              <button
                className="absolute -right-5 -top-5 z-20 flex cursor-pointer flex-col items-center justify-center"
                onClick={(e) => {
                  e.stopPropagation();
                  deleteImage(image, images ?? []);
                }}
                type="button"
              >
                <DeletePhotoIcon />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const ListingImage = React.memo(
  ({ image }: { image: ProductDocument['images'][0] }) => (
    <>
      <SafeImage
        alt="product image"
        className="rounded-lg object-cover"
        key={image.download_url}
        src={image.download_url}
        fallbackSrc={image.thumb}
        fill
      />
    </>
  )
);
ListingImage.displayName = 'ListingImage';
